/**
 * Shared helpers for LWP's write-up admin pages (admin wave 1, Bill 2026-10-29: all admin lives in the portal).
 * LWP owns src/platforms/loans/writeups/**; the shell, menu and loansApi are LOP's.
 */

import { ConsentWaitingError } from '@/platforms/hub/hubApi';
import { LoansApiError } from '../loansApi';

/** The write-up dashboard on the Loans site; ?loanItem= opens that write-up. */
export const LWP_DASHBOARD = 'https://mypcb.sharepoint.com/sites/Loans/SitePages/Consumer-Commercial-Pipeline.aspx';
export const lwpLoanLink = (id: number): string => `${LWP_DASHBOARD}?loanItem=${id}`;
/** LWP 1.517.0 deep links for the other record kinds Find returns (the dashboard opens them; drafts for admins only). */
export const lwpAdverseLink = (id: number): string => `${LWP_DASHBOARD}?advItem=${id}`;
export const lwpDraftLink = (id: number): string => `${LWP_DASHBOARD}?draftItem=${id}`;
/** The archive numbers its rows separately: ?archItem= opens exactly that archived write-up, never the active one with the same id. */
export const lwpArchiveLink = (id: number): string => `${LWP_DASHBOARD}?archItem=${id}`;

export function errorText(e: unknown): string {
  if (e instanceof ConsentWaitingError) return e.message;
  if (e instanceof LoansApiError) return e.code ? `${e.message} (${e.code})` : e.message;
  return e instanceof Error ? e.message : String(e);
}

/** Central time, which is what the loan team reads (the Activity tab made the same choice, CHG-0003). */
export function fmtCt(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return `${d.toLocaleString('en-US', { timeZone: 'America/Chicago', month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })} CT`;
}
